module.exports = __webpack_public_path__ + "static/media/coin.e4fdd4f8.png";